export const designEditorBackgroundColor = '#f7f7f7';
